"use strict";
exports.__esModule = true;
exports.LIST_PAGE_TYPES = exports.SLUG_HREF_TYPES = void 0;
var SLUG_HREF_TYPES;
(function (SLUG_HREF_TYPES) {
    SLUG_HREF_TYPES["HOTEL"] = "HOTEL";
    SLUG_HREF_TYPES["HOTELS_LIST"] = "HOTELS_LIST";
    SLUG_HREF_TYPES["STATIC"] = "STATIC";
})(SLUG_HREF_TYPES = exports.SLUG_HREF_TYPES || (exports.SLUG_HREF_TYPES = {}));
var LIST_PAGE_TYPES;
(function (LIST_PAGE_TYPES) {
    LIST_PAGE_TYPES["SPESIFIC_LIST"] = "SPESIFIC_LIST";
    LIST_PAGE_TYPES["PLACE"] = "PLACE";
})(LIST_PAGE_TYPES = exports.LIST_PAGE_TYPES || (exports.LIST_PAGE_TYPES = {}));
//# sourceMappingURL=slugs.interfaces.js.map